import { Cross2Icon } from '@radix-ui/react-icons'
import clsx from 'clsx'
import React from 'react'

import { ExclamationPoint } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'
import { INotificationIntent } from '@/ducks/notifications/slices/notification.slice'

import Styles from '../Toaster.module.scss'

const INTENT_ICONS = {
  success: <ExclamationPoint />,
  error: <ExclamationPoint />,
  info: <ExclamationPoint />,
  warning: <ExclamationPoint />
} as const

interface ISystemToasts {
  intent?: INotificationIntent
  message?: string
  onClose: () => void
}

const SystemToast: React.FC<ISystemToasts> = props => {
  const { intent = 'success', message } = props

  return (
    <div
      className={clsx(Styles.systemToast, Styles[intent])}
      data-testid="system-toast">
      <div className={Styles.iconWrapper}>{INTENT_ICONS[intent]}</div>
      <Text
        variant="nextBody"
        weight="semiBold"
        className={clsx(Styles.message)}>
        {message}
      </Text>
      <div className={Styles.closeArea}>
        <Cross2Icon />
      </div>
    </div>
  )
}

export { SystemToast }
